import React from "react";
import Modal from "./Modal";
import Icon from "../Icon";
import epiasLogo from "../../assets/img/epias-logo.svg";
import yekgLogo from "../../assets/img/yekg-logo.svg";
import moment from "moment";

export default function ModalRedemption(props) {
  const { redemptionDetail, isOpen, toggle } = props;
  const translationsTR = {
    1: "Ocak",
    2: "Şubat",
    3: "Mart",
    4: "Nisan",
    5: "Mayıs",
    6: "Haziran",
    7: "Temmuz",
    8: "Ağustos",
    9: "Eylül",
    10: "Ekim",
    11: "Kasım",
    12: "Aralık",
    BIOMASS: "Biyokütle",
    WIND: "Rüzgar",
    HYDROPOWER: "Hidroelektrik",
    GEOTHERMAL: "Jeotermal",
    SOLAR: "Güneş",
    IFSA_YESIL_TARIFE: "İfşa (Yeşil Tarife)",
    IFSA: "İfşa",
    CONSUMER: "Son Tüketici",
    PRODUCER: "Tedarikçi",
    ALUMINIUM: "Alüminyum",
    MALL_SUPER_MARKET: "AVM & Süpermarket",
    BANKING_FINANCE: "Bankacılık & Finans",
    EDUCATION: "Eğitim",
    ELECTRICAL_ELECTRONIC: "Elektrik & Elektronik",
    ENERGY: "Enerji",
    FOOD_INDUSTRY: "Gıda",
    CONSTRUCTION: "İnşaat",
    COSMETIC: "Kozmetik",
    MACHINE_CHEMISTRY_OIL: "Makine & Kimya & Petrol",
    RESIDENTIAL: "Mesken",
    METAL_MINING: "Metal & Madencilik",
    OFFICE: "Ofis",
    AUTOMOTIVE: "Otomotiv",
    HEALTH_SOCIAL_SERVICES: "Sağlık & Sosyal Hizmetler",
    INDUSTRY: "Sanayi & Endüstri",
    AGRICULTURE_LIVESTOCK: "Tarım & Hayvancılık",
    TECHNOLOGY_WHITE_GOODS: "Teknoloji & Beyaz Eşya",
    TEXTILE: "Tekstil",
    TELECOMMUNICATION: "Telekomünikasyon",
    TOURISM_HOTEL_MANAGEMENT: "Turizm & Otelcilik",
    TRANSPORTATION_LOGISTICS: "Ulaştırma & Lojistik",
    OTHER: "Diğer",
  };
  const translationsEN = {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December",
    BIOMASS: "Biomass",
    WIND: "Wind",
    HYDROPOWER: "Hydropower",
    GEOTHERMAL: "Geotermal",
    SOLAR: "Solar",
    IFSA_YESIL_TARIFE: "Disclosure (Green Tariff)",
    IFSA: "Disclosure",
    CONSUMER: "End Consumer",
    PRODUCER: "Producer",
    AGRICULTURE_LIVESTOCK: "Agriculture & Livestock",
    ALUMINIUM: "Aluminium",
    AUTOMOTIVE: "Automotive",
    BANKING_FINANCE: "Banking & Finance",
    CONSTRUCTION: "Construction",
    COSMETIC: "Cosmetic",
    EDUCATION: "Education",
    ELECTRICAL_ELECTRONIC: "Electrical & Electronic",
    ENERGY: "Energy",
    FOOD_INDUSTRY: "Food Industry",
    HEALTH_SOCIAL_SERVICES: "Health & Social Services",
    INDUSTRY: "Industry",
    MACHINE_CHEMISTRY_OIL: "Machine & Chemistry & Oil",
    MALL_SUPER_MARKET: "Mall & Super Market",
    METAL_MINING: "Metal & Mining",
    OFFICE: "Office",
    RESIDENTIAL: "Residential",
    TECHNOLOGY_WHITE_GOODS: "Technology & White Goods",
    TELECOMMUNICATION: "Telecommunication",
    TEXTILE: "Textile",
    TOURISM_HOTEL_MANAGEMENT: "Tourism & Hotel Management",
    TRANSPORTATION_LOGISTICS: "Transportation & Logistics",
    OTHER: "Other",
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} className="km__c--modal-redemption">
      <>
        <div className="km__c--modal-redemption-header">
          {/* <img src={yekgLogo} alt="" /> */}
          <div
            className="km__c--modal-redemption-header-close"
            onClick={toggle}
          >
            <Icon name="x" size="24" />
          </div>
        </div>
        <div className="km__c--modal-cancelled-redemption-body">
          <div className="km__c--modal-redemption-title-divider">
            İtfa Detayları
            <span className="km__c--modal-certificate-english">
              / Cancellation Details
            </span>
          </div>
          <div className="km__c--modal-redemption-details-full-width">
            <div
              style={{
                margin: "15px 0px",
              }}
            >
              <span>
                Yararlanıcı Taraf Adı
                <span className="km__c--modal-certificate-english">
                  / Beneficiary Name:
                </span>
              </span>
              <p
                style={{
                  paddingLeft: "5px",
                }}
              >
                {redemptionDetail.beneficiaryParty.title}
              </p>
            </div>
            <div
              style={{
                margin: "15px 0px",
              }}
            >
              <span>
                Sektör
                <span className="km__c--modal-certificate-english">
                  / Sector:
                </span>
              </span>
              <span
                className="km__c--modal-certificate-english-avoid-overflow"
                style={{
                  paddingLeft: "5px",
                  fontWeight: "normal",
                }}
              >
                {translationsTR[redemptionDetail.beneficiaryParty.sector]}
                <span className="km__c--modal-certificate-english">
                  / {translationsEN[redemptionDetail.beneficiaryParty.sector]}
                </span>{" "}
              </span>
            </div>
            <div
              style={{
                margin: "15px 0px",
              }}
            >
              <span>
                Yararlanıcı Taraf Türü{" "}
                <span className="km__c--modal-certificate-english">
                  / Beneficiary Type:
                </span>
              </span>
              <p
                className="km__c--modal-certificate-english-avoid-overflow"
                style={{
                  paddingLeft: "5px",
                  fontWeight: "normal",
                }}
              >
                {
                  translationsTR[
                    redemptionDetail.beneficiaryParty.beneficiaryPartyType
                  ]
                }
                <span className="km__c--modal-certificate-english">
                  /{" "}
                  {
                    translationsEN[
                      redemptionDetail.beneficiaryParty.beneficiaryPartyType
                    ]
                  }
                </span>{" "}
              </p>
            </div>
            <div
              style={{
                margin: "15px 0px",
              }}
            >
              <span>
                Vergi Numarası - TC Kimlik Numarası{" "}
                <span className="km__c--modal-certificate-english">
                  / Tax ID - Identity No:
                </span>
              </span>
              <p
                className="km__c--modal-certificate-english-avoid-overflow"
                style={{
                  paddingLeft: "5px",
                  fontWeight: "normal",
                }}
              >
                {redemptionDetail.beneficiaryParty.taxOrIdentityNumber}
              </p>
            </div>
            <div
              style={{
                margin: "15px 0px",
              }}
            >
              <span>
                Adres{" "}
                <span className="km__c--modal-certificate-english">
                  / Address:{" "}
                </span>
              </span>

              <span
                className="km__c--modal-certificate-english-avoid-overflow"
                style={{
                  paddingLeft: "5px",
                  fontWeight: "normal",
                }}
              >
                {" "}
                {redemptionDetail?.beneficiaryParty?.address}
                {redemptionDetail?.beneficiaryParty?.district}/
                {redemptionDetail?.beneficiaryParty?.city?.toLocaleUpperCase(
                  "tr-TR"
                )}
              </span>
            </div>
            <div
              style={{
                margin: "15px 0px",
              }}
            >
              <span>
                İtfa Amacı{" "}
                <span className="km__c--modal-certificate-english">
                  / Cancellation Purpose:{" "}
                </span>
              </span>
              <p
                style={{
                  paddingLeft: "5px",
                }}
              >
                {
                  translationsTR[
                    redemptionDetail.beneficiaryParty.redemptionPurpose
                  ]
                }
                <span className="km__c--modal-certificate-english">
                  /{" "}
                  {
                    translationsEN[
                      redemptionDetail.beneficiaryParty.redemptionPurpose
                    ]
                  }
                </span>{" "}
              </p>
            </div>
            <div
              style={{
                margin: "15px 0px",
              }}
            >
              <span>
                Tüketim Dönemi{" "}
                <span className="km__c--modal-certificate-english">
                  / Consumption Period:
                </span>
              </span>
              <span
                className="km__c--modal-certificate-english-avoid-overflow"
                style={{
                  paddingLeft: "5px",
                  fontWeight: "normal",
                }}
              >
                {
                  translationsTR[
                    moment(
                      redemptionDetail.beneficiaryParty.consumptionStartTerm
                    ).format("M")
                  ]
                }{" "}
                {moment(
                  redemptionDetail.beneficiaryParty.consumptionStartTerm
                ).format("YYYY")}{" "}
                -{" "}
                {
                  translationsTR[
                    moment(
                      redemptionDetail.beneficiaryParty.consumptionEndTerm
                    ).format("M")
                  ]
                }{" "}
                {moment(
                  redemptionDetail.beneficiaryParty.consumptionEndTerm
                ).format("YYYY")}
                <span className="km__c--modal-certificate-english">
                  /{" "}
                  {
                    translationsEN[
                      moment(
                        redemptionDetail.beneficiaryParty.consumptionStartTerm
                      ).format("M")
                    ]
                  }{" "}
                  {moment(
                    redemptionDetail.beneficiaryParty.consumptionStartTerm
                  ).format("YYYY")}{" "}
                  -{" "}
                  {
                    translationsEN[
                      moment(
                        redemptionDetail.beneficiaryParty.consumptionEndTerm
                      ).format("M")
                    ]
                  }{" "}
                  {moment(
                    redemptionDetail.beneficiaryParty.consumptionEndTerm
                  ).format("YYYY")}
                </span>
              </span>
            </div>
            <div
              style={{
                margin: "15px 0px",
              }}
            >
              <span>
                Açıklama{" "}
                <span className="km__c--modal-certificate-english">
                  / Description:
                </span>
              </span>
              <span
                className="km__c--modal-certificate-english-avoid-overflow"
                style={{
                  paddingLeft: "5px",
                  fontWeight: "normal",
                }}
              >
                {redemptionDetail.description}
              </span>
            </div>
          </div>
        </div>

        <div className="km__c--modal-redemption-footer">
          {/* <img src={epiasLogo} alt="" /> */}
        </div>
      </>
    </Modal>
  );
}
